import { render, staticRenderFns } from "./SetupAddress.vue?vue&type=template&id=11e3c9e4"
import script from "./SetupAddress.vue?vue&type=script&lang=js"
export * from "./SetupAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports